export const AWARDED = "Awarded";
export const CANCELLED = "Cancelled";
export const APPROVED = "approved";
export const DECLINED = "declined";
export const REQUESTED_CHANGES = "Requested Changes";
export const PROFORMA_INVOICED = "Proforma-Invoiced";

export const CHANGES_MODE = "ChangesMode";
export const CANCEL_MODE = "CancelMode";
